<template>
  <b-card class="no-border animated mt-3" no-body>
    <div class="item-header clearfix mb-3">
      <h5 class="pull-left mb-0 mt-2">{{displayName}}</h5>
      <div class="pull-right" v-if="canIEditCompany(detailData)">
        <b-button v-if="section === ''" @click="section = 'edit'" variant="outline-primary"><i class="fa fa-pencil-square-o"></i>&nbsp; Edit</b-button>
      </div>
    </div>
    <div class="list-group mb-2">
      <b-nav>
        <b-nav-item @click="section = ''"                 :active="section === ''"               >Preview</b-nav-item>
        <b-nav-item @click="section = 'users'"            :active="section === 'users'"          >Users</b-nav-item>
        <b-nav-item @click="section = 'vehicles'"         :active="section === 'vehicles'"       >Vehicles</b-nav-item>
        <b-nav-item @click="section = 'employees'"        :active="section === 'employees'"      >Employees</b-nav-item>
        <b-nav-item @click="section = 'partners'"         :active="section === 'partners'"       >Partners</b-nav-item>
        <b-nav-item @click="section = 'subsidiaries'"     :active="section === 'subsidiaries'"   >Subsidiaries</b-nav-item>
        <b-nav-item @click="section = 'additional'"  :active="section === 'additional'">Additional Data</b-nav-item>
        <b-nav-item v-if="this.amISystemAdmin" @click="section = 'shipment_preset'"  :active="section === 'shipment_preset'">Shipments Preset</b-nav-item>
      </b-nav>
    </div>
    <router-view></router-view>
  </b-card>
</template>
<script>
import companyMixin from '@/mixins/company';

export default {
  name: 'company_detail',
  mixins: [companyMixin],
  data() {
    const routes = this.$route.fullPath.split('/');
    const paramRoutes = (routes[4] || '').split('?');
    return {
      section: paramRoutes[0] || '',
      loaded: false,
    };
  },
  created() {
    const { companyId } = this.$route.params;
    this.$store.commit('companies/SET_DETAIL_ID', companyId);
    this.$store.commit('SET_BREADCRUMB_ITEMS', [
      { to: '', name: 'Home' },
      { to: 'admin', name: 'Admin' },
      { to: 'companies', name: 'Companies' },
      { to: companyId, name: 'Detail' },
    ]);
  },
  computed: {
    companyId() {
      return this.$route.params.companyId;
    },
    detailData() {
      return this.$store.getters['companies/get_detail_data'] || {};
    },
    displayName() {
      return this.detailData.name || '';
    },
  },
  watch: {
    section(newSection) {
      this.$router.push(`/admin/companies/${this.companyId}/${newSection}`);
    },
    companyId(newCompanyId) {
      if (newCompanyId) {
        this.$store.commit('companies/SET_DETAIL_ID', newCompanyId);
        this.$store.dispatch('companies/LOAD_DETAIL_DATA');
        this.section = '';
      }
    },
  },
};
</script>
<style>

</style>




// WEBPACK FOOTER //
// src/views/pages/admin/companies/Detail.vue